import { useState } from 'react'
import type { Question, Source, SupportSettings } from '../types'
import { QuestionCard } from '../components/QuestionCard'

interface Props { questions: Question[]; sources: Source[]; support: SupportSettings; onFinish: () => void }
export function ReviewScreen({ questions, sources, support, onFinish }: Props) {
  const [index, setIndex] = useState(0)
  const question = questions[index]
  if (!question) return <main id="main-content" className="center-page"><h1>No tienes errores pendientes</h1><button className="primary-button" onClick={onFinish}>Volver a resultados</button></main>
  return <main id="main-content" className="session-page review-page"><div className="review-heading"><p className="eyebrow">Repasar mis errores</p><p>{index + 1} de {questions.length}</p></div><QuestionCard question={question} source={sources.find((item) => item.id === question.sourceId)} support={support} onComplete={() => { if (index + 1 >= questions.length) onFinish(); else setIndex(index + 1) }} /></main>
}
